import { MovieOnlineStreamsFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

export function transformConcurrencyArbiterConfig(
    concurrencyArbiterConfig: NonNullable<MovieOnlineStreamsFragment['concurrencyArbiterConfig']>
) {
    return {
        server: concurrencyArbiterConfig.server || '',
        requestParams: concurrencyArbiterConfig.concurrencyArbiterRequestParams as Record<
            string,
            string
        >,
    };
}
